import React, { useMemo, useRef, useState } from "react";
import { Button, Col, Form, Row } from "react-bootstrap";

const DatalistInput = ({
  label,
  name,
  value,
  listId,
  options,
  onChange,
  showList,
  inputRef,
  onKeyDown,
}) => (
  <Form.Group
    as={Col}
    xs={6}
    sm={4}
    md={3}
    lg={2}
    className="filter-field"
    controlId={name}
  >
    <div className="dropdown-label">{label}</div>
    <Form.Control
      type="text"
      list={showList ? listId : undefined}
      value={value || ""}
      placeholder={label}
      autoComplete="off"
      onChange={(e) => onChange(name, e.target.value)}
      onKeyDown={onKeyDown}
      ref={inputRef}
    />
    {showList && (
      <datalist id={listId}>
        {options.map((opt, i) => (
          <option key={i} value={opt.label} />
        ))}
      </datalist>
    )}
  </Form.Group>
);

const OwnerPaymentFilter = ({
  filtered,
  handleFilterChange,
  handleFind,
  loading,
  handleReset,
  vehicles,
}) => {
  const [localFilters, setLocalFilters] = useState({
    vehicle_id: filtered.vehicle_number || "",
  });
  const dateRef = useRef(null);
  const findBtnRef = useRef(null);
  const resetBtnRef = useRef(null);

  const handleKeyDown = (e, nextRef, action) => {
    if (e.key === "Enter") {
      e.preventDefault();

      if (typeof action === "function") {
        action();
      }

      nextRef?.current?.focus();
    }
  };

  const handleInputChange = (name, value) => {
    setLocalFilters((prev) => ({ ...prev, [name]: value }));
    handleFilterChange(name, value);
  };
  return (
    <>
      <Form className="vendor-advance-filter-form">
        <Row>
          <Form.Group as={Col} xs={6} sm={4} md={3} lg={2}>
            <div className="dropdown-label">Date</div>
            <Form.Control
              type="date"
              value={localFilters.date || ""}
              onChange={(e) => handleInputChange("date", e.target.value)}
              ref={dateRef}
              onKeyDown={(e) => handleKeyDown(e, findBtnRef, handleFind)}
            />
          </Form.Group>

          <Col className="d-flex justify-content-end align-items-center">
            <Button
              variant="primary"
              className="me-2"
              onClick={handleFind}
              ref={findBtnRef}
              onKeyDown={(e) => handleKeyDown(e, resetBtnRef, handleFind)}
              disabled={loading}
            >
              {loading ? (
                <>
                  <span className="spinner-border spinner-border-sm me-2"></span>
                  Finding...
                </>
              ) : (
                "Find"
              )}
            </Button>
            <Button
              variant="secondary"
              onClick={() => {
                handleReset();
                setLocalFilters({ date: "" });
              }}
              ref={resetBtnRef}
              onKeyDown={(e) =>
                handleKeyDown(e, null, () => {
                  handleReset();
                  setLocalFilters({ date: "" });
                })
              }
            >
              Reset
            </Button>
          </Col>
        </Row>
      </Form>
    </>
  );
};

export default OwnerPaymentFilter;
